// ag-grid-enterprise v19.1.3
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var relationshipFactory = {
    getTemplate: function (config) {
        var Id = config.Id, Type = config.Type, Target = config.Target;
        return {
            name: "Relationship",
            properties: {
                rawMap: {
                    Id: Id,
                    Type: Type,
                    Target: Target
                }
            }
        };
    }
};
exports.default = relationshipFactory;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ag-grid-enterprise/dist/lib/exporter/files/ooxml/relationship.js
// module id = 1563
// module chunks = 0